import React from 'react';
import Button from './Button';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  message,
  action,
  className = '',
}) => {
  const defaultIcon = icon || (
    <svg className="h-8 w-8 text-monday-status-neutral" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
  );

  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      <div className="mx-auto w-16 h-16 rounded-2xl bg-monday-header text-monday-text-muted flex items-center justify-center mb-4 ring-1 ring-monday-border-light">
        {defaultIcon}
      </div>
      <p className="text-monday-text text-lg font-semibold tracking-tight mb-1">{title}</p>
      <p className="text-monday-text-muted text-sm mb-5 max-w-md mx-auto">{message}</p>
      {action && (
        <Button
          variant="primary"
          onClick={action.onClick}
          className="inline-flex"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
